import React, {FC} from 'react';

/** 使用指南「主图/详情图生成」tab 中文正文。2026-09-16 新增：该功能上线较新，
 * 尚无历史文档站步骤截图，正文按产品页（containers/ListingImages）已确认的功能描述
 * 组织为图文说明，不虚构界面截图。 */
const ZhContent: FC = () => {
  return (
    <>
      <h2>主图/详情图生成功能介绍</h2>
      <p>
        无需提示词，上传一张产品图或粘贴商品链接，AI 即可生成符合平台规范的电商主图、副图与详情套图，覆盖
        Amazon、Ozon、Coupang、Rakuten、Temu 等主流平台。
      </p>

      <h3>1. 上传商品图或粘贴商品链接</h3>
      <p>支持两种输入方式：直接上传一张商品实拍图或白底图，或粘贴商品链接，由系统自动采集商品主图作为生成基础。</p>

      <h3>2. AI 自动识别商品并生成视觉方案</h3>
      <p>AI 会自动完成商品识别、场景构建与卖点提炼，按选定平台的规格要求生成主图与详情图，二者分工不同：</p>
      <ul>
        <li>主图负责「停下来」：在搜索、推荐和商品列表中快速建立第一印象，决定用户要不要点进去。</li>
        <li>详情图负责「留下来」：通过卖点展示、场景呈现与信任构建，逐步消除用户疑虑，推动最终下单。</li>
      </ul>

      <h3>3. 按目标市场选择视觉风格</h3>
      <p>系统内置五大市场的视觉风格，可按目标市场直接选用，无需自行摸索当地审美：</p>
      <ul>
        <li>北美/欧洲（Amazon）：品牌型、理性、高级生活方式，版式克制，图片质感强，信息层级清晰。</li>
        <li>日本：情绪化说明型、强导购型，大标题强口号，信息热闹但层级清楚。</li>
        <li>韩国（Coupang）：生活方式种草、柔性陪伴感，场景感强，文字克制，氛围柔和。</li>
        <li>俄罗斯（Ozon）：强广告转化、直接说服，大标题、大色块，图标标签密集。</li>
        <li>东南亚：促销感强、视觉营销型，色彩活跃，促销氛围明显。</li>
      </ul>

      <h3>4. 预览效果再生成高清图</h3>
      <p>
        生成前可先查看预览图，预览图仅需 <strong>0.4 元/套</strong>；确认效果满意后，再生成高清正式图，避免浪费额度。
      </p>

      <h3>5. 下载使用</h3>
      <p>生成完成后可直接下载全部图片，用于对应平台的商品主图与详情页上传。</p>
    </>
  );
};

export default ZhContent;
